import React, { ReactNode } from 'react';
import Alert from 'src/shared/components/ui/alert';
import classNames from 'classnames';
import { CircleX as CancelOutlinedIcon } from 'lucide-react';
import styles from './ConditionalField.module.scss';

export interface ConditionalFieldProps {
    children: ReactNode;
    isSatisfied: boolean;
    showWarning?: boolean;
}

const ConditionalField = ({ children, isSatisfied, showWarning = true }: ConditionalFieldProps) => {
    const message = 'This field is not included in this subscription type';
    const conditionalFieldClass = classNames(styles.conditionalField, !showWarning && styles.conditionalFieldNoWarning);

    if (!isSatisfied) {
        const alertStyle = !showWarning ? { backgroundColor: 'transparent' } : {};
        return (
            <span className={conditionalFieldClass}>
                <Alert severity='warning' icon={<CancelOutlinedIcon />} style={alertStyle}>
                    {message}
                </Alert>
            </span>
        );
    }

    return <>{children}</>;
};

export default ConditionalField;
